<template lang="html">

  <section class="footer">
    <div class="container-link">
      <a v-for="(el, key) in $t('enlaces.contacto')" :href="el" target="_blank" rel="noopener noreferrer" :key="key">{{ key }}</a>
    </div>
    <span>
      {{ $t('enlaces.copyright') }}
    </span>
    <!-- <idioma></idioma> -->
  </section>

</template>

<script lang="js">

  import idioma from '@/components/view-parts/footer/idioma'

  export default  {
    name: 'app-footer',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {
        
    },
    components: {
      'idioma' : idioma
    }
}
</script>

<style scoped>
  .footer {
    background: #000000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 40px;
    flex-wrap: wrap;
  }
  .footer *{
    color: #ffffff;
    font-size: 14px;
    font-family: sans-serif;
  }
  .container-link{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .container-link a{
    margin-right: 25px;
  }
  @media screen and (max-width: 700px){
    .footer,.container-link{
      justify-content:center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/parts/footer.vue